'use client';

import { Flex, Skeleton, SkeletonText, Box, Drawer } from '@skin-seoul/design-system';
import React from 'react';

/**
 * Skeleton loading state for the Shopping Bag drawer
 * This component mimics the structure of CartWithItemView but with loading placeholders
 */
export const ShoppingBagSkeleton = () => {
  const renderSkeletonProductItems = () => {
    return Array(3).fill(0).map((_, index) => <React.Fragment key={index}>
          <Flex padding="16px" width="100%" flexDirection="column" gap={3}>
            <Flex width="100%" gap={3}>
              <Skeleton height="80px" width="80px" borderRadius="8px" />
              <Flex flexDirection="column" justifyContent="space-between" flex={1} gap={2}>
                <SkeletonText noOfLines={1} width="70%" />
                <SkeletonText noOfLines={1} width="40%" />
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <Skeleton height={4} width="80px" />
                  <Skeleton height={4} width="60px" />
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          {index < 2 && <Flex borderBottom="1px solid" width="100%" borderColor="neutral.10" />}
        </React.Fragment>);
  };
  return <>
      <Drawer.Header alignItems="center" display="flex" height="72px" flexDirection="row" justifyContent="space-between" padding="10px" width="100%" paddingRight="20px" data-sentry-element="Drawer.Header" data-sentry-source-file="ShoppingBagSkeleton.tsx" />

      <Drawer.Body padding="0" width="100%" overflowX="auto" paddingX="8px" data-sentry-element="Drawer.Body" data-sentry-source-file="ShoppingBagSkeleton.tsx">
        <Flex flexDirection="column" height="100%" width="100%" data-sentry-element="Flex" data-sentry-source-file="ShoppingBagSkeleton.tsx">
          {renderSkeletonProductItems()}
        </Flex>
      </Drawer.Body>

      <Flex backgroundColor="neutral.30" flexDirection="column" gap={5} height="fit-content" padding="20px" width="100%" data-sentry-element="Flex" data-sentry-source-file="ShoppingBagSkeleton.tsx">
        <Flex position="relative" flexDirection="column" width="100%" gap={5} data-sentry-element="Flex" data-sentry-source-file="ShoppingBagSkeleton.tsx">
          {/* Free Shipping Progress Skeleton */}
          <Box width="100%" padding="16px" borderRadius="8px" backgroundColor="white" data-sentry-element="Box" data-sentry-source-file="ShoppingBagSkeleton.tsx">
            <SkeletonText noOfLines={1} width="60%" data-sentry-element="SkeletonText" data-sentry-source-file="ShoppingBagSkeleton.tsx" />
          </Box>

          {/* Order Summary Skeleton */}
          <Box width="100%" padding="16px" borderRadius="8px" backgroundColor="white" data-sentry-element="Box" data-sentry-source-file="ShoppingBagSkeleton.tsx">
            <Flex justifyContent="space-between" marginBottom={2} data-sentry-element="Flex" data-sentry-source-file="ShoppingBagSkeleton.tsx">
              <SkeletonText noOfLines={1} width="30%" data-sentry-element="SkeletonText" data-sentry-source-file="ShoppingBagSkeleton.tsx" />
              <SkeletonText noOfLines={1} width="20%" data-sentry-element="SkeletonText" data-sentry-source-file="ShoppingBagSkeleton.tsx" />
            </Flex>
            <Flex justifyContent="space-between" marginTop={2} data-sentry-element="Flex" data-sentry-source-file="ShoppingBagSkeleton.tsx">
              <SkeletonText noOfLines={1} width="30%" data-sentry-element="SkeletonText" data-sentry-source-file="ShoppingBagSkeleton.tsx" />
              <SkeletonText noOfLines={1} width="20%" data-sentry-element="SkeletonText" data-sentry-source-file="ShoppingBagSkeleton.tsx" />
            </Flex>
          </Box>
        </Flex>

        {/* Checkout Button Skeleton */}
        <Skeleton height="48px" width="100%" borderRadius="8px" data-sentry-element="Skeleton" data-sentry-source-file="ShoppingBagSkeleton.tsx" />
      </Flex>
    </>;
};
export default ShoppingBagSkeleton;